import { Amplify } from 'aws-amplify';

export function configureAmplify(): void {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const domain = import.meta.env.VITE_COGNITO_DOMAIN;

  if (!userPoolId || !clientId) {
    console.warn('Cognito configuration not available');
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: clientId,
        signUpVerificationMethod: 'code',
        loginWith: domain
          ? {
              oauth: {
                domain,
                scopes: ['email', 'openid', 'profile'],
                redirectSignIn: [`${window.location.origin}/login/callback`],
                redirectSignOut: [`${window.location.origin}/`],
                responseType: 'code',
              },
            }
          : undefined,
      },
    },
  });
}
